export default __webpack_public_path__ + "static/media/Social Anxiety and Safety Behaviours worksheet.341f9a75.pdf";